module.exports = __webpack_public_path__ + "statics/img/01.5a5fc5fa.png";